import { RefObject } from 'react';
import { useEventOutside } from './useEventOutside';

export function useClickOutside(
  ref: RefObject<HTMLElement | null> | RefObject<HTMLElement | null>[],
  handler: (event: Event) => void,
  enabled = true,
) {
  useEventOutside('click', ref, handler, enabled);
}
